module.exports = __webpack_public_path__ + "img/adsms_sample_s.710f9e1c.jpg";